import React from 'react'
import classNames from 'classnames'
import axios from 'axios'
import moment from 'moment'
import immutable from 'immutable'
import _ from 'lodash'
import ScrollArea from 'react-scrollbar'

export class HistorySidebar extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            results: [],
            loading: true
        }

        _.bindAll(this,
            'scrollElement'
        )
    }

    componentDidMount() {
        axios.get('/api/v1/itineraries/' + this.props.itineraryId + '/logs/', {}).then((response) => {
            this.setState({results: _.get(response, 'data.results'), loading: false})
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.history.size > 0 && prevProps.history.size != this.props.history.size) {
            let existingHistory = this.state.results
            let newHistory = this.props.history.last().toJS()
            existingHistory.push(newHistory)
            this.setState({results: existingHistory})
        }
        // if(this.props.activeMenuItem === 'history' && prevProps.activeMenuItem !== 'history'){
        this.scrollElement()
    // }
    }

    findHistoryUser(guid) {
        let initials = ''
        let historyUser = this.props.travelers.find((user) => {
            return guid === user.get('guid')
        })

        if (typeof historyUser == 'undefined') {
            initials = 'LM'
        } else {
            initials = historyUser.get('firstname')[0] + historyUser.get('lastname')[0]
        }

        // do we need to check for how many we got? or does find() take care of that?
        return initials
    }

    convertDate(date) {
        return moment(date).format('MMM Do YYYY h:mm')
    }

    scrollElement() {
        let _this = this
        window.requestAnimationFrame(function() {
            let node = _this.refs.scrollArea
            if (node !== undefined) {
                node.scrollYTo(node.state.realHeight)
                // node.scrollBottom()
            }
        })
    }

    render() {
        let classes = classNames(
            'widget-popup',
            {'active': this.props.activeMenuItem === 'history'}
        )

        let results = this.state.results
        let historyItems = null

        if (!results || results.length === 0) {
            historyItems = <div className="history-item">No history could be found for this trip</div>
        } else {
            let logs = immutable.fromJS(results)
            historyItems = logs.map((log, index) => {
                let userInitials = this.findHistoryUser(log.get('traveler_guid'))
                let dateFormat = this.convertDate(log.get('created'))
                return (
                    <div className="sidebar-item" key={index}>
                        <div className="sidebar-user">
                            <div className="user-icon">
                                { userInitials }
                            </div>
                        </div>
                        <div>
                            <div className="sidebar-header">
                                { log.get('commit_message') }
                            </div>
                            <div className="sidebar-subheader">
                                { dateFormat }
                            </div>
                        </div>
                    </div>
                )
            })
        }
        return (
            <div id="sidebar-history" className={classes}>
                <div className="widget-header-block">
                    <i className="icon-close" onClick={() => {this.props.updateActiveMenuItem(null)}}/>
                </div>
                <div id="history-block">
                    <ScrollArea
            ref="scrollArea"
            speed={0.8}
            className="area"
            contentClassName="history-content"
            horizontal={false}>
                        { historyItems }
                    </ScrollArea>
                </div>
            </div>
        )
    }
}
